// extracted by mini-css-extract-plugin
export var list = "news-module--list--kKS3L";
export var item = "news-module--item--5hL-F";
export var time = "news-module--time--LhsGW";
export var detail = "news-module--detail--bhGcG";